var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerPage'),_c('div',{staticStyle:{"display":"flex"}},[_c('SideBar'),_vm._t("default")],2),_c('footerPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }